import { createLucideIcon } from 'lucide-react';

/**
 * Icons Lucide lacks, drawn on its 24px grid so they take the same size, stroke and
 * colour props. Used for the Farmers and Animals screens wherever they appear.
 */

/** A farmer in a wide-brimmed hat. */
export const Farmer = createLucideIcon('farmer', [
  ['path', { d: 'M3 8h18', key: 'brim' }],
  ['path', { d: 'M7 8 8 3.8A1 1 0 0 1 9 3h6a1 1 0 0 1 1 .8L17 8', key: 'crown' }],
  ['path', { d: 'M8.5 10.5a3.5 3.5 0 0 0 7 0', key: 'face' }],
  ['path', { d: 'M5 21v-1a5 5 0 0 1 5-5h4a5 5 0 0 1 5 5v1', key: 'body' }],
]);

/** A cow's head: horns, ears, eyes and muzzle. */
export const Cow = createLucideIcon('cow', [
  ['path', { d: 'M8 5.5C6.5 5 5 3.8 5 2', key: 'horn-l' }],
  ['path', { d: 'M16 5.5c1.5-.5 3-1.7 3-3.5', key: 'horn-r' }],
  ['path', { d: 'M7.2 8.5H4a1.5 1.5 0 0 0 0 3h3.5', key: 'ear-l' }],
  ['path', { d: 'M16.8 8.5H20a1.5 1.5 0 0 1 0 3h-3.5', key: 'ear-r' }],
  ['path', { d: 'M7.5 14.5 7 7.5a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2l-.5 7', key: 'head' }],
  ['rect', { x: '6', y: '14', width: '12', height: '7', rx: '3.5', key: 'muzzle' }],
  ['path', { d: 'M10 17.5h.01M14 17.5h.01M10 10h.01M14 10h.01', key: 'eyes' }],
]);
